import "styles/totalClaimedIncomeExpenses.less";
import { FC, useMemo } from "react";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Row, Flex } from "antd";
import DOMPurify from "dompurify";
import { ProfileType } from "enums/questionnaire";
import { useModalOpener } from "hooks/helpers/useModalOpener";
import { formatAmountWithCommas } from "utils/new-questionnaire";

import PromptModal from "./PromptModal";
import { CategoryPrompt } from "../../constants/categories";

type TotalClaimedIncomeExpensesProps = {
    totalAggregatedAmount: number;
    taxProfileType: ProfileType;
    title: string;
    addButtonAction?: () => void;
    infoText?: string;
};

const TotalClaimedIncomeExpenses: FC<TotalClaimedIncomeExpensesProps> = ({ totalAggregatedAmount, title, infoText, taxProfileType }) => {
    const {
        isOpened: isExplainerModalOpen,
        open: handleExplainerModalOpen,
        close: handleExplainerModalClose,
    } = useModalOpener();

    const promptModalData = useMemo(() => ({
        title: "Eligible Expense Categories",
        text: Object.values(CategoryPrompt[taxProfileType]).join(" "),
        buttonText: "Got it",
    }), [taxProfileType]);

    return (
        <div className="totalClaimedIncomeExpenses__totals-card">
            <Row className="w100" align="middle">
                <div className="totalClaimedIncomeExpenses__totals-card-title taLeft">{title}</div>
            </Row>
            <Row className="w100" align="middle" justify={"space-between"}>
                <div className="totalClaimedIncomeExpenses__totals-card-value">
                    {totalAggregatedAmount ? `£${formatAmountWithCommas(totalAggregatedAmount.toFixed(2))}` : "£0.00"}
                </div>
            </Row>
            {infoText && <Flex className="w100" justify="flex-start" align="flex-start" gap="small">
                <InfoCircleOutlined size={16} className="totalClaimedIncomeExpenses__totals-card-icon" onClick={handleExplainerModalOpen} />
                <span onClick={handleExplainerModalOpen} className="totalClaimedIncomeExpenses__totals-card-info" dangerouslySetInnerHTML={{ __html:  DOMPurify.sanitize(infoText) }}>
                </span>
            </Flex>}

            {isExplainerModalOpen && (
                <PromptModal
                    isOpen={isExplainerModalOpen}
                    closeModal={handleExplainerModalClose}
                    handlePrev={() => {}}
                    data={promptModalData}
                />
            )}
        </div>
    );
};

export default TotalClaimedIncomeExpenses;
